import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {Ease, TimelineMax} from "gsap";
import {DisplayObject} from "pixi.js";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {
    IWinPresentationConfig,
    WinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {RomanEmpireInitialWPController} from "../initial/RomanEmpireInitialWPController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";


export interface IShakeConfig {
    x: number;
    y: number;
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
    ease?: Ease;
    reverseEase?: boolean;
    positionCb?: () => PIXI.Point;
}

export interface IScatterShakeConfig {
    x?: number;
    y?: number;
    angle: number,
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
    ease?: Ease;
    reverseEase?: boolean;
    positionCb?: () => PIXI.Point;
}

export class RomanEmpireShakeEffect extends WinPresentationController {
    public static _symbolWinStates: boolean[][] = [];
    private _stopShake: boolean = false;

    private _container: PIXI.Container;
    private _isFinishCalled: boolean = false;
    private _genieFeatureLayer: PIXI.Container;

    constructor(indexes: [number, number], config: IWinPresentationConfig) {
        super(indexes, config);
        this._container = new PIXI.Container();
        this._container = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WALKING_WILD.name);
        this._genieFeatureLayer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.GINIE_FEATURE.name);
        this.addEventListener();

    }

    public Shake(config: IShakeConfig): TimelineMax {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;
        let t: boolean = true;
        const tl: TimelineMax = new TimelineMax({
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                if(config.obj.transform && config.obj.position){
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                }else{
                    Logger.logDev("transform or Position undefined ",config.obj);
                }
                if (this._stopShake || !this._isPlaying) {
                    return;
                }
                if (config.positionCb && config.obj) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
                if (!this._isFinishCalled) {
                    this.finish(false);

                }
            },
            onUpdate: () => {
                if (this._stopShake || !this._isPlaying) {
                    return;
                }
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb && config.obj) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }
                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        !this._stopShake && tl.to(this, config.duration, {});
        return tl;
    }

    protected finish(isAborted?: boolean): void {
        if (this._isFinishCalled) {
            return;
        }
        this._isFinishCalled = true;
        super.finish(isAborted);
    }

    protected symbolShakeBeforeBigWin(): void {
        this._stopShake = false;
        for (let i = 0; i < RomanEmpireGameConfig.instance.REELS_NUM; i++) {
            for (let j = 0; j < RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                if (RomanEmpireShakeEffect._symbolWinStates[i][j]) {
                    let sym = Reels.getSymbol(i, j) as DisplayObject;
                    this.Shake({
                        x: 0.1,
                        y: 0.8,
                        obj: sym,
                        duration: 2,
                        Intensity: 5,
                        hertz: 135,
                        // positionCb: () => new PIXI.Point(sym.x,sym.y),
                    }).play();
                }
            }
        }
        this.Shake({
            x: 0.1,
            y: 0.8,
            obj: this._genieFeatureLayer,
            duration: 2,
            Intensity: 5,
            hertz: 135,
            // positionCb: () => new PIXI.Point(0, 0),
        }).play();

        this.Shake({
            x: 0.1,
            y: 0.8,
            obj: this._container,
            duration: 2,
            Intensity: 5,
            hertz: 135,
            // positionCb: () => new PIXI.Point(0, 0),
        }).play();

        RomanEmpireInitialWPController.SCATTER_ANIM_CONTAINER.children.forEach((scatter: any, index) => {
            this.Shake({
                x: 0.1,
                y: 0.8,
                obj: scatter,
                duration: 2,
                Intensity: 5,
                hertz: 135,
                // positionCb: () => new PIXI.Point(0, 0),
            }).play()
        });

    }

    private addEventListener(): void {
        EventHandler.addEventListener(this, SpinEvent.START, () => this.stopShake());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this._stopShake = false);

    }

    /**
     * to stop shake on skip
     */
    private stopShake(): void {
        this._stopShake = true;
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        this._gameData = data;
        RomanEmpireShakeEffect._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(RomanEmpireGameConfig.instance.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<boolean>(RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2], () => false)
        });
    }

    protected hasWin(): boolean {
        return this._gameData!.isBigWin ? true : false;
    }

    public abort(): void {
        this.stopShake()
        super.abort();
    }

    protected startWinPresentation(): void {
        this._isFinishCalled = false;
        SoundManager.playSound(RomanEmpireSoundConfig.instance.BIG_WIN_SHAKE);
        this.symbolShakeBeforeBigWin();
    }

    protected stopWinPresentation(isAborted: boolean): void {
        // nothing to do from here
    }


}